import PropTypes from 'prop-types';
import React from 'react';
import { generateCertBlob } from '../../../../../TrainingRoutes/Certificates/Certificate/GenerateBlob';
import { httpUploadCertificate } from '../../../../../Hooks/user/user.post.hooks';
import SecondaryButton from '../../../../../Components/Buttons/SecondaryButton/SecondaryButton.component';
// Creates the certificate

const Certificate = ({ name, course, userId, setStatus }) => {
  const downloadCertificate = async (e) => {
    e.preventDefault();
    try {
      setStatus('Downloading certificate...');
      const { courseName, date, expiryDate, certNum, courseId } = course;
      const pdfBlob = await generateCertBlob(
        name,
        courseName,
        date,
        expiryDate,
        certNum
      );
      const formData = new FormData();
      formData.append('certificate', pdfBlob, `${name}-${courseName}.pdf`);
      formData.append('userId', userId);
      formData.append('courseId', courseId);
      const res = await httpUploadCertificate(formData);
      if (res.ok) {
        setStatus('Certificate downloaded successfully');
      } else {
        setStatus('Error downloading certificate');
      }
    } catch (err) {
      setStatus('Error within the backend downloading certificate');
    }
  };
  return (
    <>
      {course.date.length > 0 && (
        <SecondaryButton
          style={{ width: '30%' }}
          span="No certificate? Download"
          functionName={downloadCertificate}
        />
      )}
    </>
  );
};
Certificate.propTypes = {
  name: PropTypes.string,
  course: PropTypes.string,
  dateCompleted: PropTypes.string,
  expiryDate: PropTypes.string,
  certNumber: PropTypes.string,
  courseId: PropTypes.string,
  userId: PropTypes.string,
  setSubmitted: PropTypes.func,
  setStatus: PropTypes.func,
};

export default Certificate;
